/**
 * Single source of truth for premium features marketed in the paywall.
 * Only shipped, functional features belong here. When a new premium story
 * completes, add its feature in the same PR that marks the story complete.
 */
export const PREMIUM_FEATURES = [
  "Unlimited meals and active meal plans",
  "Unlimited recipe collections",
  "Meal plan templates",
] as const;
